import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        " {\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  display: flex;\n  height: 100%;\n  position: absolute;\n  top: 0;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { cloneElement } from "react";
import styled from "styled-components";
import Box from "../Box/Box";
import Input from "./Input";
import { scales } from "./types";
var getPadding = function(scale, hasIcon) {
    if (!hasIcon) {
        return "16px";
    }
    switch(scale){
        case scales.SM:
            return "32px";
        case scales.LG:
            return "56px";
        case scales.MD:
        default:
            return "48px";
    }
};
var StyledInputGroup = styled(Box).withConfig({
    componentId: "sc-148bad35-0"
})(_templateObject(), Input, function(param) {
    var hasStartIcon = param.hasStartIcon, scale = param.scale;
    return getPadding(scale, hasStartIcon);
}, function(param) {
    var hasEndIcon = param.hasEndIcon, scale = param.scale;
    return getPadding(scale, hasEndIcon);
});
var InputIcon = styled.div.withConfig({
    componentId: "sc-148bad35-1"
})(_templateObject1(), function(param) {
    var isEndIcon = param.isEndIcon, scale = param.scale;
    return isEndIcon ? "\n    right: ".concat(scale === scales.SM ? "8px" : "16px", ";\n  ") : "\n    left: ".concat(scale === scales.SM ? "8px" : "16px", ";\n  ");
});
var InputGroup = function(_param) /*#__PURE__*/ {
    var _scale = _param.scale, scale = _scale === void 0 ? scales.MD : _scale, startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = _object_without_properties(_param, [
        "scale",
        "startIcon",
        "endIcon",
        "children"
    ]);
    return _jsxs(StyledInputGroup, _object_spread_props(_object_spread({
        scale: scale,
        width: "100%",
        position: "relative",
        hasStartIcon: !!startIcon,
        hasEndIcon: !!endIcon
    }, props), {
        children: [
            startIcon && /*#__PURE__*/ _jsx(InputIcon, {
                scale: scale,
                children: startIcon
            }),
            /*#__PURE__*/ cloneElement(children, {
                scale: scale
            }),
            endIcon && /*#__PURE__*/ _jsx(InputIcon, {
                scale: scale,
                isEndIcon: true,
                children: endIcon
            })
        ]
    }));
};
export default InputGroup;
